import React, { Component } from 'react';
import { connect } from 'react-redux';
import CONSTS from 'constants/index.js';
import ProgressRing from 'components/ProgressRing';
import StateRing from 'components/StateRing';

export class DeltaSummaryProgress extends Component {
  resolved() {
    const toBeReviewed =
      (
        this.props.import.counts.find(
          (c) => c.review_status === CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED
        ) || {}
      ).count || 0;
    return Number(this.props.import.total) - Number(toBeReviewed);
  }

  renderProcessing() {
    return (
      <div className="DeltaSummary-progress BotStats-metricSingle">
        <div className="ringContainer">
          <StateRing
            states={{
              warning: {
                tooltip: 'Processing',
                preset: 'warning',
                icon: 'fa fa-spin fa-sync',
              },
            }}
            radius={30}
            stroke={3}
            state="warning"
            defaultState="warning"
          />
        </div>
        <div className="BotStats-metricSingleDetails">
          <div className="BotStats-metricSingleTitle">Processing</div>
          <div className="BotStats-metricSingleBody">
            Your bot import is currently being proccessed.
          </div>
        </div>
      </div>
    );
  }

  renderComitting() {
    return (
      <div className="DeltaSummary-progress BotStats-metricSingle">
        <div className="ringContainer">
          <StateRing
            states={{
              warning: {
                tooltip: 'Applying',
                preset: 'warning',
                icon: 'fa fa-spin fa-sync',
              },
            }}
            radius={30}
            stroke={3}
            state="warning"
            defaultState="warning"
          />
        </div>
        <div className="BotStats-metricSingleDetails">
          <div className="BotStats-metricSingleTitle">Applying</div>
          <div className="BotStats-metricSingleBody">
            A bot import is currently being applied.
          </div>
        </div>
      </div>
    );
  }

  renderFailedValidation() {
    return (
      <div className="DeltaSummary-progress BotStats-metricSingle">
        <div className="ringContainer">
          <StateRing
            states={{
              danger: {
                tooltip: 'Failed Validation',
                preset: 'danger',
                icon: 'fas fa-exclamation',
              },
            }}
            radius={30}
            stroke={3}
            state="danger"
            defaultState="danger"
          />
        </div>
        <div className="BotStats-metricSingleDetails">
          <div className="BotStats-metricSingleTitle">
            Import Review Progress
          </div>
          <div className="BotStats-metricSingleBody">
            Your bot import has failed please review.
          </div>
        </div>
      </div>
    );
  }

  renderProgress() {
    const total = Number(this.props.import.total);
    const makeProgress = (resolved, total) => {
      if (resolved === 0 || total === 0) {
        return 0;
      }
      return Math.round((resolved / total) * 100);
    };
    return (
      <div className="DeltaSummary-progress BotStats-metricSingle">
        <div className="ringContainer">
          <ProgressRing
            highBreakpoint={50}
            radius={30}
            stroke={3}
            progress={makeProgress(this.resolved(), total)}
          />
        </div>
        <div className="BotStats-metricSingleDetails">
          <div className="BotStats-metricSingleTitle">
            Import Review Progress
          </div>
          <div className="BotStats-metricSingleBody">
            You have reviewed {this.resolved()} of {total} answers.
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (
      [
        CONSTS.IMPORT_STATUS_NEW,
        CONSTS.IMPORT_STATUS_PROCESSING,
        CONSTS.IMPORT_STATUS_COMPLETED,
      ].includes(this.props.import.status)
    ) {
      return this.renderProcessing();
    } else if (this.props.import.status === CONSTS.IMPORT_STATUS_REVIEW) {
      return this.renderProgress();
    } else if (
      this.props.import.status === CONSTS.IMPORT_STATUS_FAILED_VALIDATION
    ) {
      return this.renderFailedValidation();
    } else if (this.props.import.status === CONSTS.IMPORT_STATUS_COMMITTED) {
      return this.renderComitting();
    }
    return null;
  }
}

const mapStateToProps = (state, props) => {
  return {
    import: state.botsRoute.importsById[props.importId],
  };
};

export default connect(mapStateToProps)(DeltaSummaryProgress);
